export default {
	ENVIADO: { text: 'Enviado', value: 'ENVIADO', ordem: 2 },
	EXPIRADO: { text: 'Expirado', value: 'EXPIRADO', ordem: 3 },
	ASSINADO: { text: 'Assinado', value: 'ASSINADO', ordem: 4 },
	EXCLUIDO: { text: 'Excluido', value: 'EXCLUIDO', ordem: 1 },
}
